export default __webpack_public_path__ + "static/media/PlayButton.10c9163e.png";